import { trackCartActions } from 'features/cart';
import { setGenericEvent } from 'features/tealium/ga4/custom';

import CartBaseItemView from '../../baseViews/ItemView';
import ViewMoodBoardTemplate from '../templates/ViewMoodBoardTemplate';

const ViewMoodBoard = CartBaseItemView.extend({
	JSXTemplate: ViewMoodBoardTemplate,
	className: 'viewMoodBoardContainer',
	ui: {
		helpFields: '.helpFields',
		link: '.viewMoodBoard'
	},
	events: {
		'click @ui.link': 'clickViewMoodBoard'
	},
	templateHelpers () {

		return {
			moodBoardLabel: this.options.moodBoardLabel || 'View Cart on Room Designer'
		};

	},
	onRender () {

		$(this.ui.link).lpTooltip({
			tooltip: $(this.ui.helpFields),
			useParentOffset: true,
			evtType: 'hover',
			offsetY: 16,
			arrow: true,
			arrowBorderWidth: 1,
			arrowSize: 15,
			borderRadius: '2px',
			boxShadow: {
				enabled: true
			}
		});

	},
	clickViewMoodBoard (e) {

		const { model } = this;
		const skus = model
			.get('ProductItems')
			.filter((p) => p.CanUseMoodBoard)
			.map((p) => p.ShortSku);

		trackCartActions({
			event_action: `Click-${e.target.innerText}`
		});

		setGenericEvent({ event_name: 'cart_roomviewer_click' });

		document.location.href = `/viewer?skus=${skus.join(',')}`;

	}
});

export default ViewMoodBoard;
